import axios from 'axios'

class AccessUrlService {

  constructor() {
    const goLive = true
    this.baseURL = process.env.VUE_APP_BACKEND_URL

    if(process.env.NODE_ENV == 'development' && goLive) {
      this.baseURL = 'https://simply-studio.appspot.com'
    }
  }
  
  async getCustomRoomsAccessURLs(user, project, secret) {
    return this.getAllAccessURLs(user, project, secret, 'rooms')
  }

  async getGalleryAccessURLs(user, project, secret) {
    return this.getAllAccessURLs(user, project, secret, 'gallery')
  }

  async getAllAccessURLs(user, project, secret, section) {
    return await axios.post(this.baseURL + '/access', 
      { 
        user: user,
        projectName: project,
        secret: secret,
        section: section
      }).then(r => r.data)
  }
}

export default new AccessUrlService()